/*
 * Zorgt dat een productformulier met een bestandsveld als multipart verstuurt.
 * Zonder dit blijft de property leeg en komt het bestand nooit bij de bestelling.
 * Schakelt ook de accelerated checkout-knoppen uit, want die kunnen geen
 * bestandsproperties meesturen.
 *
 * Vult daarnaast de zichtbare bestandsnaam naast de eigen uploadknop, omdat de
 * native tekst door de browser in zijn eigen taal wordt getekend en verborgen
 * is. Zie snippets/napkin-upload-field.liquid.
 *
 * MEERDERE BESTANDEN. Shopify neemt een bestand per property, dus de snippet
 * rendert meerdere inputs met elk hun eigen property. Alleen het eerste slot
 * staat open. De rest komt er pas bij als de klant op de knop klikt.
 *
 * De knop verschijnt zodra het laatste zichtbare slot gevuld is en verdwijnt
 * als alles openstaat. De hintregel ("You can upload up to 5 photos...")
 * verdwijnt ook zodra alle slots openstaan, want dan klopt hij niet meer.
 *
 * sync draait ook bij het laden, want een browser die het formulier herstelt na
 * een terugnavigatie zet de bestanden terug zonder change-event.
 */
(function () {
  function slotsIn(set) {
    return Array.prototype.slice.call(set.querySelectorAll('[data-napkin-upload-slot]'));
  }

  function filled(slot) {
    var input = slot.querySelector('[data-napkin-upload]');
    return Boolean(input && input.files && input.files.length);
  }

  function prepare() {
    document.querySelectorAll('[data-napkin-upload]').forEach(function (input) {
      var formId = input.getAttribute('form');
      var form = formId ? document.getElementById(formId) : input.closest('form');
      if (!form || form.dataset.napkinUploadReady) return;

      form.setAttribute('enctype', 'multipart/form-data');
      form.dataset.napkinUploadReady = 'true';

      var accelerated = form.querySelector('.shopify-payment-button, [data-shopify="payment-button"]');
      if (accelerated) accelerated.hidden = true;
    });

    document.querySelectorAll('[data-napkin-upload-set]').forEach(function (set) {
      slotsIn(set).forEach(function (slot) {
        var input = slot.querySelector('[data-napkin-upload]');
        if (input) showName(input);
      });
      sync(set);
    });
  }

  function showName(input) {
    var wrap = input.closest('.napkin-options__upload');
    if (!wrap) return;
    var target = wrap.querySelector('[data-napkin-upload-name]');
    if (!target) return;

    var file = input.files && input.files[0];
    var empty = input.getAttribute('data-empty-label') || 'No file chosen';

    target.textContent = file ? file.name : empty;
    target.classList.toggle('is-filled', Boolean(file));
  }

  /* Knop tonen zodra het laatste open slot gevuld is en er nog een over is. */
  function sync(set) {
    var button = set.querySelector('[data-napkin-upload-add]');
    var hint = set.querySelector('[data-napkin-upload-hint]');

    var slots = slotsIn(set);
    var open = slots.filter(function (slot) { return !slot.hidden; });
    var last = open[open.length - 1];
    var roomLeft = open.length < slots.length;

    if (button) button.hidden = !(roomLeft && last && filled(last));
    if (hint) hint.hidden = !roomLeft;
  }

  function addSlot(set) {
    var next = slotsIn(set).filter(function (slot) { return slot.hidden; })[0];
    if (!next) return;

    next.hidden = false;
    sync(set);

    var input = next.querySelector('[data-napkin-upload]');
    if (input) input.focus();
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-napkin-upload]')) return;
    showName(input);
    var set = input.closest('[data-napkin-upload-set]');
    if (set) sync(set);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-napkin-upload-add]');
    if (!button) return;
    var set = button.closest('[data-napkin-upload-set]');
    if (set) addSlot(set);
  });

  if (document.readyState !== 'loading') {
    prepare();
  } else {
    document.addEventListener('DOMContentLoaded', prepare);
  }
  setTimeout(prepare, 600);
  setTimeout(prepare, 1600);
})();